import { ApiModelProperty } from '@nestjs/swagger/dist/decorators/api-model-property.decorator';

export class CrudGetResponseDto<T> {
    @ApiModelProperty({
        description: 'Entity',
        type: () => Object,
    })
    entity: T;
}
